module.exports = __webpack_public_path__ + "img/user2x.png?b9f635ae41932f60546c2525d33d92a9";